var _path, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAistar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.326 0.981934L5.48631 3.55121C5.34977 3.96903 5.2815 4.17794 5.17532 4.35366C5.08124 4.5094 4.96561 4.64547 4.83328 4.75621C4.68396 4.88117 4.50645 4.96151 4.15142 5.1222L1.96826 6.1104L4.15142 7.09859C4.50645 7.25929 4.68396 7.33963 4.83328 7.4646C4.96561 7.57531 5.08124 7.71139 5.17532 7.86712C5.2815 8.04286 5.34977 8.25176 5.48631 8.66956L6.326 11.2389L7.16569 8.66956C7.30223 8.25176 7.3705 8.04286 7.47669 7.86712C7.57076 7.71139 7.68639 7.57531 7.81872 7.4646C7.96804 7.33963 8.14555 7.25929 8.50056 7.09859L10.6837 6.1104L8.50056 5.1222C8.14555 4.96151 7.96804 4.88116 7.81872 4.75621C7.68639 4.64547 7.57076 4.5094 7.47669 4.35366C7.3705 4.17794 7.30223 3.96903 7.16569 3.55121L6.326 0.981934Z",
    fill: "#20A6D2",
    stroke: "#20A6D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.0001,
    y1: 0.4,
    x2: 2.0001,
    y2: 3.6,
    stroke: "#20A6D2",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.4,
    y1: 1.9999,
    x2: 3.6,
    y2: 1.9999,
    stroke: "#20A6D2",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.0001,
    y1: 8.4,
    x2: 2.0001,
    y2: 11.6,
    stroke: "#20A6D2",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.4,
    y1: 9.9999,
    x2: 3.6,
    y2: 9.9999,
    stroke: "#20A6D2",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAistar);
export default __webpack_public_path__ + "static/media/aistar.f140550f78cf5ac7c2de571b930537b8.svg";
export { ForwardRef as ReactComponent };